<!-- {{muted|json}}
<audio id="play_ringtone" [muted]="muted" preload="auto">
  <source src="{{origin}}/assets/ringtone/latch.mp3" type="audio/ogg">
  <source src="{{origin}}/assets/ringtone/latch.mp3" type="audio/mpeg">
</audio>
<button (click)="playRing()" type="button" id="playAudiobtn">Play Audio</button> -->
<div class="token-screen-container">
  @if (title_image_id) {
  <div class="cstm-header-v1">
    <div class="header-sl">
      @if (!title_image_id) {
      <img class="sctm-top-header-img" src="/assets/images/header-bg.svg" loading="lazy" alt="">
      }
      @if (title_image_id) {
      <img class="sctm-top-header-img" [src]="title_image_id | secure  | async" loading="lazy" alt="">
      }
    </div>
  </div>
  }
  <table class="queue-table" [ngClass]="{'multi-token':MultipleTokenShow && !roomConfig,'multi-token-room-wise':MultipleTokenShow && roomConfig, 'single-token':!MultipleTokenShow}"
    [ngStyle]="{'background-color': css['body-color'],'height': 'calc(100vh - ' + getHeightOfHeader() + ')'}">
    <thead [ngStyle]="{'background-color': css['header-color']}">
      <tr [ngStyle]="{'color': css['font-color']}">
        @if (!MultipleTokenShow) {
        <th>{{ 'field.label.counter_name' | translate | async }} </th>
        }
        @if (MultipleTokenShow) {
        <th>{{ 'field.label.doctor' | translate | async }}
          @if (!roomConfig) {
          |
          <span [ngStyle]="{'color': css['room-font-color']}">{{ 'f.l.rm' | translate | async }}</span>
          }
        </th>
        }
        @if (MultipleTokenShow && roomConfig) {
        <th class="center-text" [ngStyle]="{'color': css['room-font-color']}">{{ 'f.l.rm' | translate | async }}</th>
        }
        <th class="center-text">{{ 'field.label.now_serving' | translate | async }}</th>
        @if (MultipleTokenShow) {
        @for (i of nextTokenArray; track i) {
        <th class="center-text">{{ 'field.label.next' | translate | async
          }} </th>
        }
        }
      </tr>
    </thead>
    <tbody #scrollContainer>
      <!-- CASE 1: Single Token View -->
      @if (!MultipleTokenShow && screen?.length > 0) {
      @for (r of screen[currentScreenIndex]; track r) {
      <tr
        [ngStyle]="{'height': 'calc('+(title_image_id?'76':'90')+'vh / ' + counter_per_screen + ')','color': css['font-color']}">
        <td>{{ r?.desk_name }} </td>
        <td>
          @for (p of r?.queueDeskMapping; track p; let last = $last) {
          @if (p.stage === 'Serving' || p.status === 'Serving') {
          <span class="token" [ngClass]="{  serving: p.stage === 'Serving' || p.status === 'Serving' }">
            <div class="serving-token center-text">{{ p.token }}</div>
          </span>
          }
          }
        </td>
      </tr>
      }
      }

      <!-- CASE 2: Multiple Token View -->
      @if (MultipleTokenShow && screen?.length > 0) {
      @for (r of screen[currentScreenIndex] ?? []; track r) {
      <tr
        [ngStyle]="{'height': 'calc('+(title_image_id?'76':'90')+'vh / ' + counter_per_screen + ')','color': css['font-color']}">
        <td>{{ r?.desk_name }} @if (getRoomName(r) && !roomConfig) {
          <span> |
            <span [ngStyle]="{'color': css['room-font-color']}">{{getRoomName(r)}}</span>
          </span>
          }
        </td>

        @if (roomConfig) {
        <td>
          <span [ngStyle]="{'color': css['room-font-color']}">{{getRoomName(r)}}</span>
        </td>
        }
        <!-- Now Serving -->
        <td class="text-center">
          @for (p of r?.queueDeskMapping; track p) {
          @if (p.stage === 'Serving' || p.status === 'Serving') {
          <span class="token center-text" style="font-size: 40px;">
            {{ p.token }}
          </span>
          }
          }
        </td>
        <!-- Other Tokens -->
        @if (r?.queueDeskMapping?.length > 0) {
        @for (p of getCorrectMapping(r?.queueDeskMapping); track p) {
        <!-- {{p|json}} -->
        @if
        (p.stage !== 'Serving' && p.status !== 'Serving') {
        <td class="normal_token_view text-center" class="center-text" [ngStyle]="{'color': css['font-color']}">
          {{ p.token }}
        </td>
        }
        }
        } @else {
        @for (e of nextTokenArray; track e) {
        <td class="text-center normal_token_view"></td>
        }
        }
      </tr>
      }
      }
    </tbody>
  </table>
</div>